export const UNREAD_INSIGHTS_DISPLAY_CAP = 99;

export const formatUnreadCount = (n: number, capped: boolean): string => {
  if (capped || n > UNREAD_INSIGHTS_DISPLAY_CAP) return `${UNREAD_INSIGHTS_DISPLAY_CAP}+`;
  return n.toString();
};
